module.exports = new __parcel__URL__("light.11b70086.svg").toString();